import React, { Fragment } from "react";
import "./index.less";
import { useHistory } from "react-router-dom";
import { Card, Row } from "antd";
import { Product } from "../../../domain";

type ProductCardProps = { product: Product };

export function ProductCard({ product }: ProductCardProps) {
  const history = useHistory();
  const { images, title, id } = product;
  const attribute = product.getFirstAvailableAttribute();
  const { price, offPrice } = attribute;

  const offPercent = Math.floor(((price - offPrice) / price) * 100);
  return (
    <Card
      className="product-card"
      onClick={() => history.push(`/product/${id}/${title}`)}
      cover={
        <div className="product-card-cover">
          <img src={images[0]} alt={title} width="100%" />
          {offPrice !== 0 && attribute.isAvailable() ? (
            <div className="product-card-off-badge">{`%${offPercent} تخفیف`}</div>
          ) : (
            <Fragment />
          )}
        </div>
      }
      bodyStyle={{ padding: 16 }}
      bordered={true}
      style={{ boxShadow: "0px 0px 2px 2px rgba(208, 216, 243, 0.3)" }}
    >
      <Card.Meta
        title={<span className="product-card-title">{title}</span>}
        description={
          <Fragment>
            {attribute.isAvailable() ? (
              offPrice !== 0 ? (
                <Fragment>
                  <Row justify="end">
                    <span className="product-card-off-price">
                      {price.toLocaleString("fa")} تومان
                    </span>
                  </Row>
                  <Row justify="end">
                    <span className="product-card-price-value">
                      {offPrice.toLocaleString("fa")}
                    </span>
                    <span className="product-card-price-currency">تومان</span>
                  </Row>
                </Fragment>
              ) : (
                <Row justify="end">
                  <span className="product-card-price-value">
                    {price.toLocaleString("fa")}
                  </span>
                  <span className="product-card-price-currency">تومان</span>
                </Row>
              )
            ) : (
              <Row justify="end">
                <span className="unavailable-badge">ناموجود</span>
              </Row>
            )}
          </Fragment>
        }
      />
    </Card>
  );
}
